module.exports = __webpack_public_path__ + "img/large-water-jugs-on-head.3a5bea4d.jpg";